import AddPath from "csi/def/AddPath";
import declare from "dojo/_base/declare";
import StructureItemTable from "./StructureItemTable";

const SupplierRequestsView = declare(StructureItemTable, {

	/** changed to SRM for the case of Supplier Request Master in the hierarchy */
	attributePrefix: "SR",

	/**
	 * @override
	 * Adds Limit Paths to a Supplier Request View
	 */
	onViewCreate(): void {
		const { m_rcSource, m_addPaths } = this.relRoot;
		const m_path = `Parent:${this.attributePrefix}${m_rcSource.type}`;
		m_addPaths.push(Object.assign(new AddPath(), { m_path }));
		this.inherited(arguments);
	},
});

export = SupplierRequestsView;